"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _photographyClientLib = require("@wix/photography-client-lib");
var _businessPackage = _interopRequireDefault(require("../../../assets/images/fullscreen-store/business-package.svg"));
var _info = _interopRequireDefault(require("../../../assets/images/fullscreen-store/info.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var UpgradeToBusinessPopup = exports["default"] = /*#__PURE__*/function (_Component) {
  function UpgradeToBusinessPopup() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(UpgradeToBusinessPopup, _Component);
  var _proto = UpgradeToBusinessPopup.prototype;
  _proto.onCloseClick = function onCloseClick() {
    var closePopup = this.props.closePopup;
    closePopup();
  };
  _proto.onUpgradePlanClick = function onUpgradePlanClick() {
    var businessPlanUrl = this.props.businessPlanUrl;
    window.open(businessPlanUrl, '_blank');
  };
  _proto.getUserContent = function getUserContent() {
    var _this = this;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "cp-content"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "cp-image"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: _businessPackage["default"]
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "cp-title"
    }, _photographyClientLib.translationUtils.getByKey('Gallery_ArtStore_User_Checkout_PopUp_Upgrade_Title')), /*#__PURE__*/_react["default"].createElement("div", {
      className: "cp-subtitle"
    }, _photographyClientLib.translationUtils.getByKey('Gallery_ArtStore_User_Checkout_PopUp_Upgrade_Text')), /*#__PURE__*/_react["default"].createElement("button", {
      className: "cp-button",
      onClick: function onClick() {
        return _this.onUpgradePlanClick();
      },
      target: "_blank"
    }, _photographyClientLib.translationUtils.getByKey('Gallery_ArtStore_User_Checkout_PopUp_Upgrade_CTA_Primary')), /*#__PURE__*/_react["default"].createElement("button", {
      className: "cp-secondary-button",
      onClick: function onClick() {
        return _this.onCloseClick();
      },
      target: "_blank"
    }, _photographyClientLib.translationUtils.getByKey('Gallery_ArtStore_User_Checkout_PopUp_Upgrade_CTA_Secondary')));
  };
  _proto.getUouContent = function getUouContent() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "cp-content cp-content-uou"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "cp-info-icon"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: _info["default"]
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "cp-title"
    }, _photographyClientLib.translationUtils.getByKey('Gallery_ArtStore_UoU_Checkout_PopUp_NoPaymentsConnected_Title')), /*#__PURE__*/_react["default"].createElement("div", {
      className: "cp-subtitle"
    }, _photographyClientLib.translationUtils.getByKey('Gallery_ArtStore_UoU_Checkout_PopUp_NoPaymentsConnected_Text')), /*#__PURE__*/_react["default"].createElement("button", {
      className: "cp-secondary-button",
      onClick: this.onCloseClick.bind(this),
      target: "_blank"
    }, _photographyClientLib.translationUtils.getByKey('Gallery_ArtStore_UoU_Checkout_PopUp_NoPaymentsConnected_CTA')));
  };
  _proto.getCloseIcon = function getCloseIcon() {
    var _this2 = this;
    return /*#__PURE__*/_react["default"].createElement("svg", {
      className: "cp-x-button",
      onClick: function onClick() {
        return _this2.onCloseClick();
      },
      xmlns: "http://www.w3.org/2000/svg",
      width: "12",
      height: "12",
      viewBox: "0 0 15 15"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 .6l-.6-.6-6.9 6.9L.6 0 0 .6l6.9 6.9L0 14.4l.6.6 6.9-6.9 6.9 6.9.6-.6-6.9-6.9"
    }));
  };
  _proto.render = function render() {
    var _this$props = this.props,
      viewMode = _this$props.viewMode,
      isMobile = _this$props.isMobile;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "artstore-popup-message-element " + (isMobile ? 'artstore-popup-message-element-mobile' : '')
    }, this.getCloseIcon(), viewMode === 'site' ? this.getUouContent() : this.getUserContent());
  };
  return UpgradeToBusinessPopup;
}(_react.Component);